/* tslint:disable */
/* eslint-disable */
/**
 * cellera-backend API spec
 * Backend Service for Cellera | [swagger.json](cellera/swagger.json)
 *
 * The version of the OpenAPI document: 0.1.0
 * 
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */


import * as runtime from '../runtime';
import type {
  AcceptPatientTreatmentResponseDto,
  ErrorResponse,
  GeneratePdfDto,
  GenerateTreatmentPlanForPatientDto,
  GenerateTreatmentPlanResponseDto,
  PatientAcceptedStatusResponseDto,
  SubmitFeedbackDto,
  TreatmentPlanDto,
  TreatmentPlanListResponseDto,
} from '../models/index';
import {
    AcceptPatientTreatmentResponseDtoFromJSON,
    AcceptPatientTreatmentResponseDtoToJSON,
    ErrorResponseFromJSON,
    ErrorResponseToJSON,
    GeneratePdfDtoFromJSON,
    GeneratePdfDtoToJSON,
    GenerateTreatmentPlanForPatientDtoFromJSON,
    GenerateTreatmentPlanForPatientDtoToJSON,
    GenerateTreatmentPlanResponseDtoFromJSON,
    GenerateTreatmentPlanResponseDtoToJSON,
    PatientAcceptedStatusResponseDtoFromJSON,
    PatientAcceptedStatusResponseDtoToJSON,
    SubmitFeedbackDtoFromJSON,
    SubmitFeedbackDtoToJSON,
    TreatmentPlanDtoFromJSON,
    TreatmentPlanDtoToJSON,
    TreatmentPlanListResponseDtoFromJSON,
    TreatmentPlanListResponseDtoToJSON,
} from '../models/index';

export interface AcceptPatientTreatmentRequest {
    patientId: string;
}

export interface DeleteTreatmentPlanRequest {
    id: string;
}

export interface GeneratePdfRequest {
    generatePdfDto: GeneratePdfDto;
}

export interface GenerateTreatmentPlanForPatientRequest {
    generateTreatmentPlanForPatientDto: GenerateTreatmentPlanForPatientDto;
}

export interface GetPatientAcceptedStatusRequest {
    patientId: string;
}

export interface GetTreatmentPlanByIdRequest {
    id: string;
}

export interface GetTreatmentPlansRequest {
    pageSize: number;
    page?: number;
    nextPageToken?: string;
    search?: string;
    generatedBy?: GetTreatmentPlansGeneratedByEnum;
    dateRange?: GetTreatmentPlansDateRangeEnum;
    customStartDate?: string;
    customEndDate?: string;
    sortBy?: GetTreatmentPlansSortByEnum;
    sortOrder?: GetTreatmentPlansSortOrderEnum;
}

export interface GetTreatmentPlansByPatientRequest {
    patientId: string;
    pageSize: number;
    page?: number;
    nextPageToken?: string;
    search?: string;
    generatedBy?: GetTreatmentPlansByPatientGeneratedByEnum;
    dateRange?: GetTreatmentPlansByPatientDateRangeEnum;
    customStartDate?: string;
    customEndDate?: string;
    sortBy?: GetTreatmentPlansByPatientSortByEnum;
    sortOrder?: GetTreatmentPlansByPatientSortOrderEnum;
}

export interface GetTreatmentPlansByUserIdRequest {
    page: number;
    pageSize: number;
}

export interface SubmitFeedbackRequest {
    submitFeedbackDto: SubmitFeedbackDto;
}

/**
 * 
 */
export class TreatmentPlanApi extends runtime.BaseAPI {

    /**
     * Update patient\'s treatment plan acceptance status to accepted. If already accepted, returns current status.
     * Accept patient treatment plan
     */
    async acceptPatientTreatmentRaw(requestParameters: AcceptPatientTreatmentRequest, initOverrides?: RequestInit | runtime.InitOverrideFunction): Promise<runtime.ApiResponse<AcceptPatientTreatmentResponseDto>> {
        if (requestParameters['patientId'] == null) {
            throw new runtime.RequiredError(
                'patientId',
                'Required parameter "patientId" was null or undefined when calling acceptPatientTreatment().'
            );
        }

        const queryParameters: any = {};

        const headerParameters: runtime.HTTPHeaders = {};

        if (this.configuration && this.configuration.accessToken) {
            const token = this.configuration.accessToken;
            const tokenString = await token("bearer", []);

            if (tokenString) {
                headerParameters["Authorization"] = `Bearer ${tokenString}`;
            }
        }
        const response = await this.request({
            path: `/treatment-plan/patient/{patientId}/accept-treatment`.replace(`{${"patientId"}}`, encodeURIComponent(String(requestParameters['patientId']))),
            method: 'POST',
            headers: headerParameters,
            query: queryParameters,
        }, initOverrides);

        return new runtime.JSONApiResponse(response, (jsonValue) => AcceptPatientTreatmentResponseDtoFromJSON(jsonValue));
    }

    /**
     * Update patient\'s treatment plan acceptance status to accepted. If already accepted, returns current status.
     * Accept patient treatment plan
     */
    async acceptPatientTreatment(requestParameters: AcceptPatientTreatmentRequest, initOverrides?: RequestInit | runtime.InitOverrideFunction): Promise<AcceptPatientTreatmentResponseDto> {
        const response = await this.acceptPatientTreatmentRaw(requestParameters, initOverrides);
        return await response.value();
    }

    /**
     * Deletes a treatment plan by ID. Only the provider who created it can delete it. The patient will no longer see this protocol.
     * Delete a treatment plan (Doctor only)
     */
    async deleteTreatmentPlanRaw(requestParameters: DeleteTreatmentPlanRequest, initOverrides?: RequestInit | runtime.InitOverrideFunction): Promise<runtime.ApiResponse<void>> {
        if (requestParameters['id'] == null) {
            throw new runtime.RequiredError(
                'id',
                'Required parameter "id" was null or undefined when calling deleteTreatmentPlan().'
            );
        }

        const queryParameters: any = {};

        const headerParameters: runtime.HTTPHeaders = {};

        if (this.configuration && this.configuration.accessToken) {
            const token = this.configuration.accessToken;
            const tokenString = await token("bearer", []);

            if (tokenString) {
                headerParameters["Authorization"] = `Bearer ${tokenString}`;
            }
        }
        const response = await this.request({
            path: `/treatment-plan/{id}`.replace(`{${"id"}}`, encodeURIComponent(String(requestParameters['id']))),
            method: 'DELETE',
            headers: headerParameters,
            query: queryParameters,
        }, initOverrides);

        return new runtime.VoidApiResponse(response);
    }

    /**
     * Deletes a treatment plan by ID. Only the provider who created it can delete it. The patient will no longer see this protocol.
     * Delete a treatment plan (Doctor only)
     */
    async deleteTreatmentPlan(requestParameters: DeleteTreatmentPlanRequest, initOverrides?: RequestInit | runtime.InitOverrideFunction): Promise<void> {
        await this.deleteTreatmentPlanRaw(requestParameters, initOverrides);
    }

    /**
     * Generates a PDF for a treatment plan (provider only)
     * Generate PDF for treatment plan
     */
    async generatePdfRaw(requestParameters: GeneratePdfRequest, initOverrides?: RequestInit | runtime.InitOverrideFunction): Promise<runtime.ApiResponse<void>> {
        if (requestParameters['generatePdfDto'] == null) {
            throw new runtime.RequiredError(
                'generatePdfDto',
                'Required parameter "generatePdfDto" was null or undefined when calling generatePdf().'
            );
        }

        const queryParameters: any = {};

        const headerParameters: runtime.HTTPHeaders = {};

        headerParameters['Content-Type'] = 'application/json';

        if (this.configuration && this.configuration.accessToken) {
            const token = this.configuration.accessToken;
            const tokenString = await token("bearer", []);

            if (tokenString) {
                headerParameters["Authorization"] = `Bearer ${tokenString}`;
            }
        }
        const response = await this.request({
            path: `/treatment-plan/generate-pdf`,
            method: 'POST',
            headers: headerParameters,
            query: queryParameters,
            body: GeneratePdfDtoToJSON(requestParameters['generatePdfDto']),
        }, initOverrides);

        return new runtime.VoidApiResponse(response);
    }

    /**
     * Generates a PDF for a treatment plan (provider only)
     * Generate PDF for treatment plan
     */
    async generatePdf(requestParameters: GeneratePdfRequest, initOverrides?: RequestInit | runtime.InitOverrideFunction): Promise<void> {
        await this.generatePdfRaw(requestParameters, initOverrides);
    }

    /**
     * Generates a treatment plan for the authenticated patient
     * Generate treatment plan for a patient
     */
    async generateTreatmentPlanRaw(initOverrides?: RequestInit | runtime.InitOverrideFunction): Promise<runtime.ApiResponse<void>> {
        const queryParameters: any = {};

        const headerParameters: runtime.HTTPHeaders = {};

        if (this.configuration && this.configuration.accessToken) {
            const token = this.configuration.accessToken;
            const tokenString = await token("bearer", []);

            if (tokenString) {
                headerParameters["Authorization"] = `Bearer ${tokenString}`;
            }
        }
        const response = await this.request({
            path: `/treatment-plan/generate`,
            method: 'POST',
            headers: headerParameters,
            query: queryParameters,
        }, initOverrides);

        return new runtime.VoidApiResponse(response);
    }

    /**
     * Generates a treatment plan for the authenticated patient
     * Generate treatment plan for a patient
     */
    async generateTreatmentPlan(initOverrides?: RequestInit | runtime.InitOverrideFunction): Promise<void> {
        await this.generateTreatmentPlanRaw(initOverrides);
    }

    /**
     * Generates a treatment plan for a specific patient (practice access)
     * Generate treatment plan for a specific patient
     */
    async generateTreatmentPlanForPatientRaw(requestParameters: GenerateTreatmentPlanForPatientRequest, initOverrides?: RequestInit | runtime.InitOverrideFunction): Promise<runtime.ApiResponse<GenerateTreatmentPlanResponseDto>> {
        if (requestParameters['generateTreatmentPlanForPatientDto'] == null) {
            throw new runtime.RequiredError(
                'generateTreatmentPlanForPatientDto',
                'Required parameter "generateTreatmentPlanForPatientDto" was null or undefined when calling generateTreatmentPlanForPatient().'
            );
        }

        const queryParameters: any = {};

        const headerParameters: runtime.HTTPHeaders = {};

        headerParameters['Content-Type'] = 'application/json';

        if (this.configuration && this.configuration.accessToken) {
            const token = this.configuration.accessToken;
            const tokenString = await token("bearer", []);

            if (tokenString) {
                headerParameters["Authorization"] = `Bearer ${tokenString}`;
            }
        }
        const response = await this.request({
            path: `/treatment-plan/generate-for-patient`,
            method: 'POST',
            headers: headerParameters,
            query: queryParameters,
            body: GenerateTreatmentPlanForPatientDtoToJSON(requestParameters['generateTreatmentPlanForPatientDto']),
        }, initOverrides);

        return new runtime.JSONApiResponse(response, (jsonValue) => GenerateTreatmentPlanResponseDtoFromJSON(jsonValue));
    }

    /**
     * Generates a treatment plan for a specific patient (practice access)
     * Generate treatment plan for a specific patient
     */
    async generateTreatmentPlanForPatient(requestParameters: GenerateTreatmentPlanForPatientRequest, initOverrides?: RequestInit | runtime.InitOverrideFunction): Promise<GenerateTreatmentPlanResponseDto> {
        const response = await this.generateTreatmentPlanForPatientRaw(requestParameters, initOverrides);
        return await response.value();
    }

    /**
     * Check if a patient has accepted their treatment plan. This endpoint only reads the status without updating it.
     * Get patient accepted treatment plan status
     */
    async getPatientAcceptedStatusRaw(requestParameters: GetPatientAcceptedStatusRequest, initOverrides?: RequestInit | runtime.InitOverrideFunction): Promise<runtime.ApiResponse<PatientAcceptedStatusResponseDto>> {
        if (requestParameters['patientId'] == null) {
            throw new runtime.RequiredError(
                'patientId',
                'Required parameter "patientId" was null or undefined when calling getPatientAcceptedStatus().'
            );
        }

        const queryParameters: any = {};

        const headerParameters: runtime.HTTPHeaders = {};

        if (this.configuration && this.configuration.accessToken) {
            const token = this.configuration.accessToken;
            const tokenString = await token("bearer", []);

            if (tokenString) {
                headerParameters["Authorization"] = `Bearer ${tokenString}`;
            }
        }
        const response = await this.request({
            path: `/treatment-plan/patient/{patientId}/accepted-status`.replace(`{${"patientId"}}`, encodeURIComponent(String(requestParameters['patientId']))),
            method: 'GET',
            headers: headerParameters,
            query: queryParameters,
        }, initOverrides);

        return new runtime.JSONApiResponse(response, (jsonValue) => PatientAcceptedStatusResponseDtoFromJSON(jsonValue));
    }

    /**
     * Check if a patient has accepted their treatment plan. This endpoint only reads the status without updating it.
     * Get patient accepted treatment plan status
     */
    async getPatientAcceptedStatus(requestParameters: GetPatientAcceptedStatusRequest, initOverrides?: RequestInit | runtime.InitOverrideFunction): Promise<PatientAcceptedStatusResponseDto> {
        const response = await this.getPatientAcceptedStatusRaw(requestParameters, initOverrides);
        return await response.value();
    }

    /**
     * Retrieves a specific treatment plan by its ID
     * Get treatment plan by ID
     */
    async getTreatmentPlanByIdRaw(requestParameters: GetTreatmentPlanByIdRequest, initOverrides?: RequestInit | runtime.InitOverrideFunction): Promise<runtime.ApiResponse<TreatmentPlanDto>> {
        if (requestParameters['id'] == null) {
            throw new runtime.RequiredError(
                'id',
                'Required parameter "id" was null or undefined when calling getTreatmentPlanById().'
            );
        }

        const queryParameters: any = {};

        const headerParameters: runtime.HTTPHeaders = {};

        if (this.configuration && this.configuration.accessToken) {
            const token = this.configuration.accessToken;
            const tokenString = await token("bearer", []);

            if (tokenString) {
                headerParameters["Authorization"] = `Bearer ${tokenString}`;
            }
        }
        const response = await this.request({
            path: `/treatment-plan/{id}`.replace(`{${"id"}}`, encodeURIComponent(String(requestParameters['id']))),
            method: 'GET',
            headers: headerParameters,
            query: queryParameters,
        }, initOverrides);

        return new runtime.JSONApiResponse(response, (jsonValue) => TreatmentPlanDtoFromJSON(jsonValue));
    }

    /**
     * Retrieves a specific treatment plan by its ID
     * Get treatment plan by ID
     */
    async getTreatmentPlanById(requestParameters: GetTreatmentPlanByIdRequest, initOverrides?: RequestInit | runtime.InitOverrideFunction): Promise<TreatmentPlanDto> {
        const response = await this.getTreatmentPlanByIdRaw(requestParameters, initOverrides);
        return await response.value();
    }

    /**
     * Retrieves all treatment plans with pagination
     * Get all treatment plans
     */
    async getTreatmentPlansRaw(requestParameters: GetTreatmentPlansRequest, initOverrides?: RequestInit | runtime.InitOverrideFunction): Promise<runtime.ApiResponse<TreatmentPlanListResponseDto>> {
        if (requestParameters['pageSize'] == null) {
            throw new runtime.RequiredError(
                'pageSize',
                'Required parameter "pageSize" was null or undefined when calling getTreatmentPlans().'
            );
        }

        const queryParameters: any = {};

        if (requestParameters['page'] != null) {
            queryParameters['page'] = requestParameters['page'];
        }

        if (requestParameters['pageSize'] != null) {
            queryParameters['pageSize'] = requestParameters['pageSize'];
        }

        if (requestParameters['nextPageToken'] != null) {
            queryParameters['nextPageToken'] = requestParameters['nextPageToken'];
        }

        if (requestParameters['search'] != null) {
            queryParameters['search'] = requestParameters['search'];
        }

        if (requestParameters['generatedBy'] != null) {
            queryParameters['generatedBy'] = requestParameters['generatedBy'];
        }

        if (requestParameters['dateRange'] != null) {
            queryParameters['dateRange'] = requestParameters['dateRange'];
        }

        if (requestParameters['customStartDate'] != null) {
            queryParameters['customStartDate'] = requestParameters['customStartDate'];
        }

        if (requestParameters['customEndDate'] != null) {
            queryParameters['customEndDate'] = requestParameters['customEndDate'];
        }

        if (requestParameters['sortBy'] != null) {
            queryParameters['sortBy'] = requestParameters['sortBy'];
        }

        if (requestParameters['sortOrder'] != null) {
            queryParameters['sortOrder'] = requestParameters['sortOrder'];
        }

        const headerParameters: runtime.HTTPHeaders = {};

        if (this.configuration && this.configuration.accessToken) {
            const token = this.configuration.accessToken;
            const tokenString = await token("bearer", []);

            if (tokenString) {
                headerParameters["Authorization"] = `Bearer ${tokenString}`;
            }
        }
        const response = await this.request({
            path: `/treatment-plan`,
            method: 'GET',
            headers: headerParameters,
            query: queryParameters,
        }, initOverrides);

        return new runtime.JSONApiResponse(response, (jsonValue) => TreatmentPlanListResponseDtoFromJSON(jsonValue));
    }

    /**
     * Retrieves all treatment plans with pagination
     * Get all treatment plans
     */
    async getTreatmentPlans(requestParameters: GetTreatmentPlansRequest, initOverrides?: RequestInit | runtime.InitOverrideFunction): Promise<TreatmentPlanListResponseDto> {
        const response = await this.getTreatmentPlansRaw(requestParameters, initOverrides);
        return await response.value();
    }

    /**
     * Retrieves treatment plans for a specific patient with pagination
     * Get treatment plans by patient ID
     */
    async getTreatmentPlansByPatientRaw(requestParameters: GetTreatmentPlansByPatientRequest, initOverrides?: RequestInit | runtime.InitOverrideFunction): Promise<runtime.ApiResponse<TreatmentPlanListResponseDto>> {
        if (requestParameters['patientId'] == null) {
            throw new runtime.RequiredError(
                'patientId',
                'Required parameter "patientId" was null or undefined when calling getTreatmentPlansByPatient().'
            );
        }

        if (requestParameters['pageSize'] == null) {
            throw new runtime.RequiredError(
                'pageSize',
                'Required parameter "pageSize" was null or undefined when calling getTreatmentPlansByPatient().'
            );
        }

        const queryParameters: any = {};

        if (requestParameters['page'] != null) {
            queryParameters['page'] = requestParameters['page'];
        }

        if (requestParameters['pageSize'] != null) {
            queryParameters['pageSize'] = requestParameters['pageSize'];
        }

        if (requestParameters['nextPageToken'] != null) {
            queryParameters['nextPageToken'] = requestParameters['nextPageToken'];
        }

        if (requestParameters['search'] != null) {
            queryParameters['search'] = requestParameters['search'];
        }

        if (requestParameters['generatedBy'] != null) {
            queryParameters['generatedBy'] = requestParameters['generatedBy'];
        }

        if (requestParameters['dateRange'] != null) {
            queryParameters['dateRange'] = requestParameters['dateRange'];
        }

        if (requestParameters['customStartDate'] != null) {
            queryParameters['customStartDate'] = requestParameters['customStartDate'];
        }

        if (requestParameters['customEndDate'] != null) {
            queryParameters['customEndDate'] = requestParameters['customEndDate'];
        }

        if (requestParameters['sortBy'] != null) {
            queryParameters['sortBy'] = requestParameters['sortBy'];
        }

        if (requestParameters['sortOrder'] != null) {
            queryParameters['sortOrder'] = requestParameters['sortOrder'];
        }

        const headerParameters: runtime.HTTPHeaders = {};

        if (this.configuration && this.configuration.accessToken) {
            const token = this.configuration.accessToken;
            const tokenString = await token("bearer", []);

            if (tokenString) {
                headerParameters["Authorization"] = `Bearer ${tokenString}`;
            }
        }
        const response = await this.request({
            path: `/treatment-plan/patient/{patientId}`.replace(`{${"patientId"}}`, encodeURIComponent(String(requestParameters['patientId']))),
            method: 'GET',
            headers: headerParameters,
            query: queryParameters,
        }, initOverrides);

        return new runtime.JSONApiResponse(response, (jsonValue) => TreatmentPlanListResponseDtoFromJSON(jsonValue));
    }

    /**
     * Retrieves treatment plans for a specific patient with pagination
     * Get treatment plans by patient ID
     */
    async getTreatmentPlansByPatient(requestParameters: GetTreatmentPlansByPatientRequest, initOverrides?: RequestInit | runtime.InitOverrideFunction): Promise<TreatmentPlanListResponseDto> {
        const response = await this.getTreatmentPlansByPatientRaw(requestParameters, initOverrides);
        return await response.value();
    }

    /**
     * Retrieves treatment plans for a specific user ID without any filters
     * Get treatment plans by user ID
     */
    async getTreatmentPlansByUserIdRaw(requestParameters: GetTreatmentPlansByUserIdRequest, initOverrides?: RequestInit | runtime.InitOverrideFunction): Promise<runtime.ApiResponse<TreatmentPlanListResponseDto>> {
        if (requestParameters['page'] == null) {
            throw new runtime.RequiredError(
                'page',
                'Required parameter "page" was null or undefined when calling getTreatmentPlansByUserId().'
            );
        }

        if (requestParameters['pageSize'] == null) {
            throw new runtime.RequiredError(
                'pageSize',
                'Required parameter "pageSize" was null or undefined when calling getTreatmentPlansByUserId().'
            );
        }

        const queryParameters: any = {};

        if (requestParameters['page'] != null) {
            queryParameters['page'] = requestParameters['page'];
        }

        if (requestParameters['pageSize'] != null) {
            queryParameters['pageSize'] = requestParameters['pageSize'];
        }

        const headerParameters: runtime.HTTPHeaders = {};

        if (this.configuration && this.configuration.accessToken) {
            const token = this.configuration.accessToken;
            const tokenString = await token("bearer", []);

            if (tokenString) {
                headerParameters["Authorization"] = `Bearer ${tokenString}`;
            }
        }
        const response = await this.request({
            path: `/treatment-plan/user`,
            method: 'GET',
            headers: headerParameters,
            query: queryParameters,
        }, initOverrides);

        return new runtime.JSONApiResponse(response, (jsonValue) => TreatmentPlanListResponseDtoFromJSON(jsonValue));
    }

    /**
     * Retrieves treatment plans for a specific user ID without any filters
     * Get treatment plans by user ID
     */
    async getTreatmentPlansByUserId(requestParameters: GetTreatmentPlansByUserIdRequest, initOverrides?: RequestInit | runtime.InitOverrideFunction): Promise<TreatmentPlanListResponseDto> {
        const response = await this.getTreatmentPlansByUserIdRaw(requestParameters, initOverrides);
        return await response.value();
    }

    /**
     * Submits feedback for a treatment plan and triggers reprocessing with feedback
     * Submit feedback for treatment plan
     */
    async submitFeedbackRaw(requestParameters: SubmitFeedbackRequest, initOverrides?: RequestInit | runtime.InitOverrideFunction): Promise<runtime.ApiResponse<void>> {
        if (requestParameters['submitFeedbackDto'] == null) {
            throw new runtime.RequiredError(
                'submitFeedbackDto',
                'Required parameter "submitFeedbackDto" was null or undefined when calling submitFeedback().'
            );
        }

        const queryParameters: any = {};

        const headerParameters: runtime.HTTPHeaders = {};

        headerParameters['Content-Type'] = 'application/json';

        if (this.configuration && this.configuration.accessToken) {
            const token = this.configuration.accessToken;
            const tokenString = await token("bearer", []);

            if (tokenString) {
                headerParameters["Authorization"] = `Bearer ${tokenString}`;
            }
        }
        const response = await this.request({
            path: `/treatment-plan/submit-feedback`,
            method: 'POST',
            headers: headerParameters,
            query: queryParameters,
            body: SubmitFeedbackDtoToJSON(requestParameters['submitFeedbackDto']),
        }, initOverrides);

        return new runtime.VoidApiResponse(response);
    }

    /**
     * Submits feedback for a treatment plan and triggers reprocessing with feedback
     * Submit feedback for treatment plan
     */
    async submitFeedback(requestParameters: SubmitFeedbackRequest, initOverrides?: RequestInit | runtime.InitOverrideFunction): Promise<void> {
        await this.submitFeedbackRaw(requestParameters, initOverrides);
    }

}

/**
 * @export
 */
export const GetTreatmentPlansGeneratedByEnum = {
    All: 'all',
    You: 'you',
    Practice: 'practice'
} as const;
export type GetTreatmentPlansGeneratedByEnum = typeof GetTreatmentPlansGeneratedByEnum[keyof typeof GetTreatmentPlansGeneratedByEnum];
/**
 * @export
 */
export const GetTreatmentPlansDateRangeEnum = {
    AllTime: 'all_time',
    Last7Days: 'last_7_days',
    Last3Months: 'last_3_months',
    Last6Months: 'last_6_months',
    Last12Months: 'last_12_months',
    CustomRange: 'custom_range'
} as const;
export type GetTreatmentPlansDateRangeEnum = typeof GetTreatmentPlansDateRangeEnum[keyof typeof GetTreatmentPlansDateRangeEnum];
/**
 * @export
 */
export const GetTreatmentPlansSortByEnum = {
    GeneratedOn: 'generated_on'
} as const;
export type GetTreatmentPlansSortByEnum = typeof GetTreatmentPlansSortByEnum[keyof typeof GetTreatmentPlansSortByEnum];
/**
 * @export
 */
export const GetTreatmentPlansSortOrderEnum = {
    Asc: 'asc',
    Desc: 'desc'
} as const;
export type GetTreatmentPlansSortOrderEnum = typeof GetTreatmentPlansSortOrderEnum[keyof typeof GetTreatmentPlansSortOrderEnum];
/**
 * @export
 */
export const GetTreatmentPlansByPatientGeneratedByEnum = {
    All: 'all',
    You: 'you',
    Practice: 'practice'
} as const;
export type GetTreatmentPlansByPatientGeneratedByEnum = typeof GetTreatmentPlansByPatientGeneratedByEnum[keyof typeof GetTreatmentPlansByPatientGeneratedByEnum];
/**
 * @export
 */
export const GetTreatmentPlansByPatientDateRangeEnum = {
    AllTime: 'all_time',
    Last7Days: 'last_7_days',
    Last3Months: 'last_3_months',
    Last6Months: 'last_6_months',
    Last12Months: 'last_12_months',
    CustomRange: 'custom_range'
} as const;
export type GetTreatmentPlansByPatientDateRangeEnum = typeof GetTreatmentPlansByPatientDateRangeEnum[keyof typeof GetTreatmentPlansByPatientDateRangeEnum];
/**
 * @export
 */
export const GetTreatmentPlansByPatientSortByEnum = {
    GeneratedOn: 'generated_on'
} as const;
export type GetTreatmentPlansByPatientSortByEnum = typeof GetTreatmentPlansByPatientSortByEnum[keyof typeof GetTreatmentPlansByPatientSortByEnum];
/**
 * @export
 */
export const GetTreatmentPlansByPatientSortOrderEnum = {
    Asc: 'asc',
    Desc: 'desc'
} as const;
export type GetTreatmentPlansByPatientSortOrderEnum = typeof GetTreatmentPlansByPatientSortOrderEnum[keyof typeof GetTreatmentPlansByPatientSortOrderEnum];
